// Français — France
export default {
  translation: {
    app_name: 'Ledxo Hub',
    tagline: 'Là où les hobbies créent des communautés',
    nav_explore: 'Explorer',
    nav_find_folks: 'Trouver des gens',
    nav_sign_in: 'Se connecter',
    nav_join_free: 'Rejoindre gratuitement',
    nav_sign_out: 'Se déconnecter',
    nav_my_profile: 'Mon profil',
    nav_notifications: 'Notifications',
    auth_register: 'Créer un compte',
    auth_login: 'Se connecter',
    auth_name: 'Nom complet',
    auth_email: 'Adresse e-mail',
    auth_password: 'Mot de passe',
    auth_age: 'Votre âge',
    auth_city: 'Ville',
    auth_building: 'Résidence / Immeuble',
    auth_country: 'Pays',
    auth_currency: 'Devise',
    auth_locale: 'Langue et région',
    auth_already_have_account: 'Déjà inscrit ?',
    auth_no_account: 'Pas encore de compte ?',
    postcode_label: 'Code postal',
    postcode_placeholder: 'ex. 75001',
    profile_edit: 'Modifier le profil',
    profile_bio: 'Biographie',
    profile_interests: 'Centres d\'intérêt',
    profile_location: 'Localisation',
    profile_theme: 'Thème d\'affichage',
    profile_currency_settings: 'Devise et région',
    profile_save: 'Enregistrer',
    profile_cancel: 'Annuler',
    group_join: 'Rejoindre',
    group_leave: 'Quitter',
    group_members: 'Membres',
    group_chat: 'Discussion',
    group_events: 'Événements',
    group_shop: 'Boutique',
    group_campaigns: 'Campagnes',
    group_about: 'À propos',
    group_full: 'Complet',
    group_open: 'Ouvert',
    tip_send: 'Envoyer un pourboire',
    tip_amount: 'Montant',
    tip_message: 'Message (optionnel)',
    wallet_coins: 'pièces',
    wallet_balance: 'Solde',
    tips_earned: 'gagnés',
    event_register: "S'inscrire",
    event_unregister: 'Se désinscrire',
    event_ticket_price: 'Billet',
    event_free: 'Gratuit',
    event_capacity: 'Capacité',
    event_registered: 'inscrit(s)',
    no_results: 'Aucun résultat',
    loading: 'Chargement…',
    error_generic: 'Une erreur est survenue. Veuillez réessayer.',
  }
};
